import React, { FC } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

interface DeleteConfirmationDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  content?: string;
}

const DeleteConfirmationDialog: FC<DeleteConfirmationDialogProps> = ({
  open,
  onCancel,
  onConfirm,
  title = "Aus der Liste entfernen?",
  content = "",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="delete-dialog-title"
    >
      <DialogTitle
        id="delete-dialog-title"
        className="dialog-title"
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          {/* <WarningIcon color="warning" /> */}
          {title}
        </div>
      </DialogTitle>
      <DialogContent className="dialog-content">
        <DialogContentText id="delete-dialog-description">{content}</DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button onClick={onCancel}>Nein</Button>
        <Button onClick={onConfirm}>Ja, Entfernen</Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
